export default "__VITE_ASSET__o7mQ9I46__"